import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from '../../hooks';
import { Link } from 'react-router-dom';
import SideMenu from '../SideMenu/SideMenu';
import ToastNotification from '../Notification/toast';
import PopModalDialog from '../PopModalDialog/PopModalDialog';
import Button from '../Button/Button';

import styles from './Header.module.css';
import logo from '../../assets/logo.svg';
import icBroadcast from '../../assets/ic-broadcast.svg';
import icMovie from '../../assets/ic-movie.svg';
import icAnimationMenu from '../../assets/ic-animation.svg';
import icLiveTVMenu from '../../assets/ic-live-tv.svg';
import icHome from '../../assets/ic-home.svg';
const BottomBar = () => {
  const router = useRouter();
  const menu = [
    {
      name: 'Home',
      path: '/',
      icon: icHome,
    },
    {
      name: 'Live',
      path: '/live',
      icon: icBroadcast,
    },
    {
      name: 'Clips',
      path: '/clips',
      icon: icMovie,
    },
    {
      name: 'Live TV',
      path: '/live-tv',
      icon: icLiveTVMenu,
    },
  ];
  return (
    <div className={`${styles['bottomBar']} show-mobile`}>
      {menu?.map((item) => {
        const selected = router?.location?.pathname === item.path;
        return (
          <div className={styles.menuIcon}>
            <img src={item.icon} alt={item.name} />
            <div className={selected ? styles['selected'] : ''}>
              <Link to={item.path}>{item.name}</Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BottomBar;
